import React, { Component } from 'react';
// import { CommonTableLoader } from '../CommonTableLoader';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { Pagination } from '../Pagination';
import classes from "./style.module.scss";
import Loader from '../Loader';


const TableWrapper = (props) => {
    const {
        headerDetails = [],
        listLength = [],
        pageMeta = {},
        handlePageChange = {},
        isLoading = false,
        highlightRows = false,
        sortConfig = {},
        setSortConfig
    } = props;


    const handleSort = (key) => {
        if (sortConfig?.key === key) {
            setSortConfig({ key: key, direction: sortConfig?.direction === 'asc' ? 'desc' : 'asc' })
        } else {
            setSortConfig({ key: key, direction: 'desc' })
        }
    };

    return (
        <div className={`${classes.maintableStriped} ${highlightRows ? classes.highlight : ''}`}>
            <div className="">
                <table className={`${classes.table}`}>
                    <thead>
                        <tr>
                            {headerDetails.map(({ label, sortable = '' }) => (
                                <th key={label}>
                                    <div key={label} className={`flex items-center justify-center text-center`} onClick={() => (listLength.length !== 0 && sortable) ? handleSort(sortable) : null}>
                                        <div>{label}</div>
                                        {(listLength.length !== 0 && sortable && sortConfig?.key === sortable) ?
                                            <span>
                                                <ArrowForwardIosSharpIcon className={`${classes.sortingArrow} ${(sortConfig && sortConfig?.key === sortable && sortConfig?.direction === 'desc') ? classes.arrowActive : ''}`} />
                                            </span> : null
                                        }
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <td colSpan={headerDetails.length}>
                                <div className="w-[100%] h-[300px] flex items-center !justify-center">Loading...</div>
                            </td>
                            // <Loader/>
                        ) :
                            listLength.length !== 0 ? (

                                props.children
                            ) : (
                                <td colSpan={headerDetails.length}>
                                    <p className="w-[100%] h-[300px] flex items-center !justify-center">
                                        No records found !!!
                                    </p>
                                </td>
                            )
                        }
                    </tbody>
                </table>
            </div>
            <Pagination pageMeta={pageMeta} handlePageChange={handlePageChange} />
        </div>
    );
}

export default TableWrapper;